<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-dark px-5">
      <!-- Logo -->
      <a class="navbar-brand" href="https://cekkazan.com.tr/" target="_blank">
        <img src="@/assets/images/logo_white.png" alt="Çek Kazan Logo" height="40" />
      </a>

      <!-- Hamburger button -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarContent"
        aria-controls="navbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Menü içeriği -->
      <div class="collapse navbar-collapse" id="navbarContent">
        <!-- Sol Menü Linkleri -->
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link" href="https://kampanya.cekkazan.com.tr/" target="_blank">Anasayfa</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://cekkazan.com.tr/sikca-sorulan-sorular" target="_blank">Sıkça Sorulan Sorular</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://cekkazan.com.tr/kampanyalar" target="_blank">Diğer Kampanyalar</a>
          </li>
        </ul>

        <!-- Sağ İkonlar -->
        <div class="d-flex">
          <a class="nav-link" href="https://www.instagram.com/cekkazan/" target="_blank" rel="noopener">
            <img src="@/assets/icons/instagram.png" alt="Instagram" width="24" height="24" />
          </a>
          <a class="nav-link" href="https://www.facebook.com/cekkazan/" target="_blank" rel="noopener">
            <img src="@/assets/icons/facebook.png" alt="Facebook" width="24" height="24" />
          </a>
        </div>
      </div>
    </nav>
  </header>
</template>



